<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">首页</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      活动管理
      <small>管理商城的各种活动...</small>
    </h1>
    <!-- end page-header -->
    <panel title="活动列表" :noButton="true">
      <div slot="heading-btn">
        <button type="button" class="btn btn-theme btn-sm" @click="fn_add">
          <i class="fa fa-plus"></i> 添加活动
        </button>
      </div>

      <Row :gutter="5">
        <Col span="5">
          <Input v-model="filterCond.title" placeholder="标题"></Input>
        </Col>
        <Col span="3">
          <Button type="primary" class="btn btn-theme" @click="fn_query">查询</Button>
        </Col>
      </Row>

      <Table border size="small" :columns="columns" :data="data" class="m-t-10">
        <template slot-scope="{row}" slot="activitytype">
          <span v-if="row.activitytype =='recharger'">充值活动</span>
          <span v-else-if="row.activitytype =='coupon'">商品优惠券</span>
        </template>
        <template slot-scope="{ row }" slot="status">
          <strong v-if="row.status==0">有效</strong>
          <strong v-else style="color:red">无效</strong>
        </template>
        <template slot-scope="{row}" slot="beginenddate">
          开始:{{row.begindate}}
          <br />
          结束:{{row.enddate}}
        </template>
        <template slot-scope="{row}" slot="ispublic">
          <span v-if="row.jointype == 'open'">无条件</span>
          <span v-else-if="row.jointype =='share'">分享({{row.sharenum}})</span>
          <span v-else-if="row.jointype =='follow'">关注注册</span>
          <span v-else-if="row.jointype =='buy'">买后获取</span>
          <span v-else-if="row.jointype =='integral'">积分兑换</span>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <button
            type="button"
            class="btn btn-theme btn-sm"
            style="margin-right: 5px"
            @click="fn_edit(row,index)"
          >活动管理</button>

          <Poptip
            transfer
            confirm
            title="是否要删除此活动?"
            @on-ok="fn_remove(row,index)"
            ok-text="确认"
            cancel-text="取消"
          >
            <button type="button" class="btn btn-danger btn-sm">删除</button>
          </Poptip>
        </template>
      </Table>
      <Page
        style="margin-top:10px"
        :total="totalRows"
        :current="currentPage"
        :page-size="pageNum"
        show-total
        show-elevator
        @on-change="fn_switchPage"
      />
    </panel>

    <Drawer title="活动管理" v-model="v_edit_activity" width="80" :mask-closable="true">
      <Tabs value="name1">
        <TabPane label="活动信息" name="name1">
          <Form :model="formData" ref="formData" :rules="rules" :labelWidth="120">
            <Row>
              <Col span="12">
                <FormItem label="类型" prop="activitytype">
                  <Select v-model="formData.activitytype">
                    <Option value="recharger">充值活动</Option>
                    <Option value="coupon">商品优惠券</Option>
                  </Select>
                </FormItem>
                <FormItem label="名称" prop="name">
                  <Input v-model="formData.name" />
                </FormItem>
                <FormItem label="标题" prop="title">
                  <Input v-model="formData.title" />
                </FormItem>
              </Col>
              <Col span="6">
                <FormItem label="活动条件" prop="jointype">
                  <Select v-model="formData.jointype">
                    <Option value="open">无条件</Option>
                    <Option value="share">分享获取</Option>
                    <Option value="follow">关注注册</Option>
                    <Option value="buy">买后获取</Option>
                    <Option value="integral">积分兑换</Option>
                  </Select>
                </FormItem>
                <FormItem label="开始时间" prop="begindate">
                  <DatePicker type="datetime" style="width:100%" v-model="formData.begindate" />
                </FormItem>
                <FormItem label="结束时间" prop="enddate">
                  <DatePicker type="datetime" style="width:100%" v-model="formData.enddate" />
                </FormItem>
              </Col>
              <Col span="6">
                <FormItem v-if="formData.jointype =='share'" label="分享数量要求">
                  <InputNumber style="width:100%" v-model="formData.sharenum"></InputNumber>
                </FormItem>

                <FormItem label="活动图片">
                  <Upload
                    name="filename"
                    :show-upload-list="false"
                    :action="uploadhost"
                    :format="['jpg','jpeg','png']"
                    :on-success="fn_uploadSuccess"
                    :max-size="2048"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    style="display: inline-block;width:90px;"
                  >
                    <Button icon="ios-cloud-upload-outline">上传图片</Button>
                  </Upload>
                </FormItem>
                <FormItem label="活动图">
                  <img :src="logourl+formData.logo" style="max-height:100px" />
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span="6">
                <FormItem label="数量限制">
                  <InputNumber style="width:100%" v-model="formData.numlimit"></InputNumber>
                </FormItem>
              </Col>
              <Col span="6">
                <FormItem label="-1不限制数量">积分兑换的由奖品数量来限制</FormItem>
              </Col>
              <Col span="6" v-if="formData.activitytype == 'coupon'">
                <FormItem label="优惠券有效期[天]">
                  <InputNumber style="width:100%" v-model="formData.couponvalidday"></InputNumber>
                </FormItem>
              </Col>
              <Col span="6">
                <FormItem label="状态" prop="status">
                  <Select v-model="formData.status">
                    <Option :value="-1">无效</Option>
                    <Option :value="0">有效</Option>
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <!-- <Row v-if="formData.activitytype=='coupon' && formData.jointype =='integral'">
              <Col span="6">
                <FormItem label="兑换积分数">
                  <InputNumber style="width:100%" v-model="formData.exchangeintegral"></InputNumber>
                </FormItem>
              </Col>
              <Col span="8">
                <p class="m-t-5" style="color:red">数量为0表示不能用积分进行兑换</p>
              </Col>
            </Row>-->
            <FormItem label="备注" prop="remarks">
              <Input type="textarea" v-model="formData.remarks" />
            </FormItem>
            <FormItem label="活动计算设置">
              <table class="table table-bordered">
                <thead>
                  <th width="15%">开始金额</th>
                  <th width="15%">结束金额</th>
                  <th width="15%">增加减少</th>
                  <th width="15%">计算方法</th>
                  <th width="15%">计算值</th>
                  <th>
                    <a href="javascript:void(0)" @click="fn_add_item">
                      <i class="fa fa-plus"></i> 增加
                    </a>
                  </th>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in formDataItem" :key="index">
                    <td style="padding:0px 0px 0px 0px">
                      <InputNumber style="width:100%" v-model="item.startval"></InputNumber>
                    </td>
                    <td style="padding:0px 0px 0px 0px">
                      <InputNumber style="width:100%" v-model="item.endval"></InputNumber>
                    </td>
                    <td style="padding:0px 0px 0px 0px">
                      <Select v-model="item.direct">
                        <Option value="add">增加</Option>
                        <Option value="minus">减少</Option>
                      </Select>
                    </td>
                    <td style="padding:0px 0px 0px 0px">
                      <Select v-model="item.calmethod">
                        <Option value="absolute">绝对值</Option>
                        <Option value="precent">百分比</Option>
                      </Select>
                    </td>
                    <td style="padding:0px 0px 0px 0px">
                      <InputNumber style="width:100%" v-model="item.calvalue"></InputNumber>
                    </td>
                    <td style="padding:2px 1px 0px 2px">
                      <Poptip confirm title="你要删除此活动设置吗?" @on-ok="fn_remove_item(item,index)">
                        <button type="button" class="btn btn-danger btn-sm">删除</button>
                      </Poptip>
                    </td>
                  </tr>
                </tbody>
              </table>
            </FormItem>
          </Form>
        </TabPane>
        <TabPane label="活动海报" name="name2">
          <div class="editor-wrapper">
            <div :id="editorId"></div>
          </div>
        </TabPane>
      </Tabs>

      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px" @click="v_edit_activity = false">关闭</Button>
        <Button type="primary" @click="fn_store_activity">保存</Button>
      </div>
    </Drawer>
  </div>
</template>
<script>
import {
  getActivityList,
  removeActivityData,
  removeActivityDataItem,
  storeActivityData
} from "@/api/activity";
import moment from "moment";

import { getToken } from "@/libs/util";
import config from "@/config";
import Editor from "wangeditor";
import "wangeditor/release/wangEditor.css";

export default {
  data() {
    return {
      uploadhost: config.baseUrl.pro + "/upload/uploadfile",
      logourl: config.baseUrl.imageurl,
      filterCond: {
        page: 1,
        pageNum: 10,
        title: ""
      },
      columns: [
        {
          title: "#",
          key: "id",
          width: 50
        },
        {
          title: "名称",
          key: "name",
          width: 200
        },
        {
          title: "类型",
          slot: "activitytype",
          width: 100
        },
        {
          title: "标题",
          key: "title",
          width: 250
        },

        {
          title: "时间",
          slot: "beginenddate",
          width: 180
        },
        {
          title: "权限",
          slot: "ispublic",
          width: 100
        },
        {
          title: "数量",
          key: "numlimit",
          width: 70
        },
        {
          title: "备注",
          key: "remarks"
        },
        {
          title: "状态",
          slot: "status",
          width: 90
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "left",
          fixed: "right"
        }
      ],
      data: [],

      totalRows: 0,
      pageNum: 10,
      currentPage: 1,

      formData: {
        id: 0,
        activitytype: "",
        title: "",
        name: "",
        begindate: moment().format("YYYY-MM-DD HH:mm:ss"),
        enddate: moment().format("YYYY-MM-DD HH:mm:ss"),
        content: "",
        jointype: "open",
        remarks: "",
        numlimit: 0,
        status: 0,
        exchangeintegral: 0
      },
      rules: {
        activitytype: [
          {
            required: true,
            message: "类型必填",
            trigger: "change"
          }
        ],
        name: [
          {
            required: true,
            message: "名称必填",
            trigger: "blur"
          }
        ],
        title: [
          {
            required: true,
            message: "标题必填",
            trigger: "blur"
          }
        ]
      },
      formDataItem: [],
      v_edit_activity: false
    };
  },
  mounted() {
    this.filterCond = {
      page: 1,
      pageNum: this.pageNum
    };
    this.fn_load_data(this.filterCond);
    this.iniRichText();
  },
  computed: {
    editorId() {
      return `editor${this._uid}`;
    }
  },
  methods: {
    fn_uploadSuccess(res, file) {
      if (file.response.code === 200) {
        this.formData.logo = file.response.data;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式不正确",
        desc:
          "文件 " + file.name + " 格式不正确，请上传 jpg 或 png 格式的图片。"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超出文件大小限制",
        desc: "文件 " + file.name + " 太大，不能超过 2M。"
      });
    },
    fn_query() {
      this.filterCond.page = 1;
      this.fn_load_data(this.filterCond);
    },
    fn_add() {
      this.v_edit_activity = true;
      this.formData = {
        id: 0,
        activitytype: "",
        title: "",
        name: "",
        begindate: moment().format("YYYY-MM-DD HH:mm:ss"),
        enddate: moment()
          .add(30, "day")
          .format("YYYY-MM-DD HH:mm:ss"),
        content: "",
        ispublic: 1,
        remarks: "",
        status: 0,
        exchangeintegral: 0
      };
      console.log(this.formData);
    },
    fn_load_data(filterCond) {
      getActivityList(filterCond).then(res => {
        this.data = res.data.data;
        this.totalRows = res.data.total;
      });
    },
    fn_switchPage(page) {
      this.currentPage = page;
      let filterCond = {
        page: page,
        pageNum: this.pageNum
      };
      this.fn_load_data(filterCond);
    },
    fn_edit(row, index) {
      this.formData = row;
      this.formDataItem = row.items;
      this.editor.txt.html(this.formData.content);
      this.v_edit_activity = true;
    },
    fn_add_item() {
      let data = {
        id: 0,
        activityid: this.formData.id,
        startval: 0,
        endval: 0,
        direct: "add",
        calmethod: "absolute",
        calvalue: 0,
        numlimit: -1
      };
      this.formDataItem.push(data);
    },
    fn_store_activity() {
      this.formData.begindate = moment(this.formData.begindate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formData.enddate = moment(this.formData.enddate).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      console.log(this.formData, this.formDataItem);
      this.$refs.formData.validate(valid => {
        if (valid) {
          storeActivityData(this.formData, this.formDataItem)
            .then(res => {
              if (res.data.code == 200) {
                if (this.formData.id == 0) {
                  this.fn_switchPage(1);
                }
                this.v_edit_activity = false;
                this.$Notice.success({
                  title: "成功",
                  desc: res.data.desc
                });
              } else {
                this.$Notice.error({
                  title: "失败",
                  desc: res.data.desc
                });
              }
            })
            .catch(error => {
              this.$Message.error(error);
            });
        }
      });
    },
    fn_remove(row, index) {
      removeActivityData(row.id)
        .then(res => {
          if (res.data.code == 200) {
            this.data.splice(index, 1);
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_remove_item(item, index) {
      if (item.id > 0) {
        removeActivityDataItem(item.id).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
            this.formDataItem.splice(index, 1);
          } else {
            this.$Notice.error(res.data);
          }
        });
      } else {
        this.formDataItem.splice(index, 1);
      }
    },
    iniRichText() {
      // console.log(this.Field.columname, this.FieldListData);
      this.editor = new Editor(`#${this.editorId}`);
      this.editor.customConfig.onchange = html => {
        let text = this.editor.txt.text();
        if (this.cache) localStorage.editorCache = html;
        this.$emit("input", this.valueType === "html" ? html : text);
        this.$emit("on-change", html, text);
      };
      this.editor.customConfig.onchangeTimeout = this.changeInterval;
      // create这个方法一定要在所有配置项之后调用
      this.editor.customConfig.zIndex = 1; // 设置菜单的垂直高度

      this.editor.customConfig.uploadImgServer = this.uploadhost;
      //  "http://47.106.198.122/api/CanteenAdmin/CanteenManagement/UploadImage"; // 配置服务器端地址
      this.editor.customConfig.uploadImgHeaders = {
        Authorization: "Bearer" + getToken()
      }; // 自定义 header
      this.editor.customConfig.uploadFileName = "filename"; // 后端接受上传文件的参数名
      this.editor.customConfig.uploadImgMaxSize = 2 * 1024 * 1024; // 将图片大小限制为 2M
      this.editor.customConfig.uploadImgMaxLength = 6; // 限制一次最多上传 3 张图片
      this.editor.customConfig.uploadImgTimeout = 3 * 60 * 1000; // 设置超时时间
      // this.editor.customConfig.uploadParams = {formFile:'2'};
      // 配置菜单
      this.editor.customConfig.menus = [
        "head",
        "bold", // 粗体
        "fontSize", // 字号
        "fontName", // 字体
        "italic", // 斜体
        "underline", // 下划线
        "strikeThrough", // 删除线
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "link", // 插入链接
        "list", // 列表
        "justify", // 对齐方式
        "quote", // 引用
        "emoticon", // 表情
        "image", // 插入图片
        "table", // 表格
        "video", // 插入视频
        "code", // 插入代码
        "undo", // 撤销
        "redo" // 重复
      ];

      this.editor.customConfig.uploadImgHooks = {
        fail: (xhr, editor, result) => {
          // 插入图片失败回调
        },
        success: (xhr, editor, result) => {
          // 图片上传成功回调
          //
          let imgUrl = result.data;
          insertImg(imgUrl);
        },
        timeout: (xhr, editor) => {
          // 网络超时的回调
        },
        error: (xhr, editor) => {
          console.log(editor);
          // 图片上传错误的回调
        },
        customInsert: (insertImg, result, editor) => {
          // 图片上传成功,插入图片的回调

          // if(result.code == 200){
          var url = this.logourl + result.data;
          //   console.log(url);
          insertImg(url); //将内容插入到富文本中
          // console.log(insertImg(url)+"DFDF")
          // console.log(data+"dsfd")
          // }
        }
      };

      this.editor.customConfig.onchange = html => {
        this.info_ = html; // 绑定当前逐渐地值
        this.$emit("change", this.info_); // 将内容同步到父组件中
        this.formData.content = html;
      };

      // 创建富文本编辑器

      this.editor.create();
      // 如果本地有存储加载本地存储内容
    }
  }
};
</script>
